import styled, { css } from "styled-components"
import { transparentize } from "polished"

const StyledSpotlightWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => transparentize(0.15, theme.color.main01)};
  display: flex;
  z-index: 101;
`

const StyledProjectWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
`

const StyledHeadingWrapper = styled.div`
  position: absolute;
  padding: 1.6rem;
  top: ${({ isBannerActive }) => (isBannerActive ? "15.5rem" : "10rem")};
  background: white;
  visibility: hidden;
  visibility: visible;
`
const StyledLocationIconRect = styled.div`
  width: 0.4rem;
  height: 0.4rem;
  background: ${({ theme }) => theme.color.white};
  transform: rotate(45deg);
`

const StyledLocationIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.secondary02};
  flex-shrink: 0;
  margin-right: 0.4rem;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${({ theme }) => theme.color.main03};
    `}
`
const StyledAddressWrapper = styled.div`
  margin-top: 0.8rem;
  display: flex;
  font-size: ${({ theme }) => theme.font.size.xs};
  letter-spacing: 0.25px;
`
const StyledPOI = styled.div`
  position: absolute;
  left: ${({ left }) => `${left}px`};
  top: ${({ top }) => `${top}px`};

  width: ${({ iconSize }) => `${iconSize}px`};
  height: ${({ iconSize }) => `${iconSize}px`};

  background: ${({ theme }) => theme.color.main03};
  border-radius: 50%;

  &:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;

    width: 0.6rem;
    height: 0.6rem;

    background: white;
    transform: translateY(-50%) translateX(-50%) rotate(45deg);
  }
`

export {
  StyledHeadingWrapper,
  StyledSpotlightWrapper,
  StyledProjectWrapper,
  StyledLocationIconRect,
  StyledLocationIcon,
  StyledAddressWrapper,
  StyledPOI,
}
